import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './components/Home';
import Navbar from "./components/NavBar";
import Products from './components/Products';
import ProductDetails from './components/ProductDetails';
import Cart from './components/Cart';
import Footer from './components/Footer';
import Checkout from './components/Checkout';
import ThankYouPage from './components/ThankYouPage';
import Contact from './components/Contact';
import Resellers from './components/Resellers';
import ComingSoon from './components/ComingSoon';
import ResellerRegistration from './components/resellers/ResellerRegistration';
import { CartProvider } from './context/CartContext'; // Importar el CartProvider

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para mostrar la UI de respaldo
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Puedes enviar el error a un servicio de reporte de errores
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Algo salió mal. Por favor, intenta nuevamente más tarde.</h1>;
    }

    return this.props.children;
  }
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <CartProvider>  {/* Rodeamos toda la aplicación con el CartProvider */}
          <Router>
            <Navbar />
            <div className="content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/product/:name" element={<ProductDetails />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />}  />
                <Route path='/thank-you/:orderNumber' element={<ThankYouPage />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/resellers' element={<Resellers />} />
                <Route path='/comming-soon' element={<ComingSoon />} />
                <Route path='/register' element={<ResellerRegistration />} />
              </Routes>
            </div>
            <Footer />
          </Router>
        </CartProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;